import React from 'react';
import { Skeleton } from './Skeleton';

/**
 * Skeleton Chart - for chart/graph placeholders
 */
export const SkeletonChart = ({
  height = '300px',
  type = 'bar', // bar, line, pie, donut
  hasLegend = true,
  hasTitle = true,
  className = ''
}) => {
  const renderChartContent = () => {
    switch (type) {
      case 'pie':
      case 'donut':
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Skeleton
              variant="circular"
              height="200px"
            />
          </div>
        );

      case 'line':
        return (
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', height: '100%', gap: '0.5rem' }}>
            {Array.from({ length: 8 }).map((_, index) => (
              <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                <Skeleton
                  width="100%"
                  height={`${Math.random() * 60 + 40}%`}
                />
              </div>
            ))}
          </div>
        );

      case 'bar':
      default:
        return (
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', height: '100%', gap: '0.5rem' }}>
            {Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                key={index}
                width="15%"
                height={`${Math.random() * 60 + 40}%`}
              />
            ))}
          </div>
        );
    }
  };

  return (
    <div
      className={`skeleton-chart ${className}`}
      style={{
        backgroundColor: 'var(--color-surface, #fff)',
        padding: '1.5rem',
        borderRadius: '0.75rem',
        border: '1px solid #e2e8f0'
      }}
    >
      {/* Title */}
      {hasTitle && (
        <Skeleton
          width="40%"
          height="1.5rem"
          style={{ marginBottom: '1.5rem' }}
        />
      )}

      {/* Chart */}
      <div style={{ height, marginBottom: hasLegend ? '1rem' : 0 }}>
        {renderChartContent()}
      </div>

      {/* Legend */}
      {hasLegend && (
        <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Skeleton width="12px" height="12px" borderRadius="2px" />
              <Skeleton width="60px" height="0.875rem" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SkeletonChart;
